






























































import {Component, Vue} from 'vue-property-decorator';
import JdsJobTileListLayout from "@/design-system/constructs/JobTile/JdsJobTileListLayout.vue"
import JdsJobTile from "@/design-system/constructs/JobTile/JdsJobTile.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsRichDropdown from "@/design-system/components/RichDropdown/JdsRichDropdown.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsPageLayout from "@/design-system/patterns/Page/JdsPageLayout.vue"
import JdsPageIntro from "@/design-system/patterns/Page/JdsPageIntro.vue"
import JdsPageTitle from "@/design-system/patterns/Page/JdsPageTitle.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdsPaginator from "@/design-system/components/Paginator/JdsPaginator.vue"
import JdsLoader from "@/design-system/foundation/JdsLoader.vue"
import JdsPageSection from "@/design-system/patterns/Page/JdsPageSection.vue"
import JdsFilterBar from "@/design-system/forms/filters/JdsFilterBar.vue"
import { Job, JobStatus, JobCampaignStatus } from '@/design-system/constructs/JobTile/JobTileViewModel';

@Component({
    components: {
        JdsFilterBar,
        JdsPageSection,
        JdsLoader,
        JdsPaginator,
        JdsGlyph,
        JdsPageTitle,
        JdsPageIntro,
        JdsPageLayout, JdsIcon, JdsRichDropdown,
        // JdsTextInput,
        JdsButton, JdsJobTile, JdsJobTileListLayout
    }
})
export default class JdpJobIndex extends Vue {
    loading = true

    mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 1200)
    }

    get jobs(): Job[] {
        return [
            {
                title: 'Senior Dev',
                id: 1,
                location: 'London',
                activeFrom: '2021-01-10T11:30:10+00:00',
                activeTo: '2023-08-10T11:30:10+00:00',
                isStarred: true,
                status: JobStatus.PROCESSING,
                campaignStatus: JobCampaignStatus.EXPIRED,
                pipeline: {
                    entry: 44,
                    other: 12,
                    hire: 0,
                    rejection: 23,
                },
            },
            {
                title: 'Designer',
                id: 2,
                location: 'London',
                activeFrom: '2023-01-10T11:30:10+00:00',
                activeTo: '2023-03-10T11:30:10+00:00',
                isStarred: true,
                status: JobStatus.OPEN,
                campaignStatus: JobCampaignStatus.ACTIVE,
                pipeline: {
                    entry: 44,
                    other: 12,
                    hire: 0,
                    rejection: 923,
                },
            },
            {
                title: 'Senior Dev',
                id: 3,
                location: 'London',
                activeFrom: '2021-01-10T11:30:10+00:00',
                activeTo: '2021-08-10T11:30:10+00:00',
                isStarred: true,
                status: JobStatus.COMPLETED,
                campaignStatus: JobCampaignStatus.EXPIRED,
                isArchived: true,
                pipeline: {
                    entry: 44,
                    other: 12,
                    hire: 0,
                    rejection: 223,
                },
            },
            {
                id: 238337,
                location: 'Blaviken',
                is_hidden: false,
                status: JobStatus.OPEN,
                title: 'Butcher',
                active_from: '2022-04-29T22:00:00+00:00',
                active_to: null,
                first_hired_at: '2022-09-22T07:43:48+00:00',
                archived_at: null,
                campaigns: [
                    {
                        id: '1d6867f0-961b-4fce-aed1-11801d99eb22',
                        job_id: 238337,
                        status: 'ended',
                        starts_at: '2022-06-14T00:00:00+00:00',
                        ends_at: '2022-06-27T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '42725167-6ba3-4238-9efb-dbea0675cc13',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-10-14T00:00:00+00:00',
                        ends_at: '2022-10-28T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '6dbd862b-1fbe-4fa2-85db-7996a04f608e',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-08-12T00:00:00+00:00',
                        ends_at: '2022-08-26T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '71a484d7-8bc3-4e8f-954e-86ffc71adc78',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-08-29T00:00:00+00:00',
                        ends_at: '2022-09-12T00:00:00+00:00',
                        title: 'Frontend developer',
                        intro: 'Hey developer! Would you be interested to work for Jobilla? We got:\n\nHigh quality work equipment\n\nPossibility to focus to your work\n\nPossibility to full remote work\n\nExperienced and friendly team\n\nPossibility to constantly develop yourself on work time\n\nInterested? Answer few questions and test if Jobilla would fit for you!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://questionnaires.jobilla.com/40c4e370-cc3e-11eb-af8f-97630d7cfffb',
                        is_active: false,
                    },
                ],
                pipeline: {
                    entry: 2,
                    other: 11,
                    hire: 3,
                    rejection: 2,
                },
                number_of_unread_mails: 0,
                subscribers: [
                    {
                        id: 24455,
                        name: 'Vladimir Andronov 20220630',
                        email: 'vladimir.andronov+20220630@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: null,
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 6922,
                        name: 'Ilan Moatty',
                        email: 'ilan.moatty@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: null,
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 2376,
                        name: 'Antti Rössi',
                        email: 'antti.rossi2@outlook.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: 'yMKOP2MBXSIBew77GNzIhUE5.jpg',
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 6843,
                        name: 'Anton',
                        email: 'anton.peraviortau@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: 'https://storage.googleapis.com/jobilla-uploads-staging/user/attachment/danSzyt8TcLgWb9IKon7EKOa.jpeg',
                        avatar: 'https://images.staging.jobilla.com/user/attachment/danSzyt8TcLgWb9IKon7EKOa.jpeg?fm=webp&width=undefined',
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                ],
                is_starred: false,
            },
        ];
    }
}
